<template>
  <div>

    <Dialog
      :dismissableMask="true"
      style="width: 20vw !important;"
      :header="title"
      :style="{ width: '20vw' }"
      :modal="true"
      :visible.sync="show"
      @hide="emitChoice(false)"
      :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <i style=" transform: scale(1.7); " class="pi  pi-trash"></i>
        <h1>{{title}}</h1>
      </template>
      <div class="p-pt-4 confirmation-content">
        <i class="pi pi-exclamation-triangle p-ml-3" style="font-size: 2rem" />
        <span>{{ context }}</span>
      </div>
      <template #footer>
        <Button
          label="ביטול"
          icon="pi pi-times "
          class="p-button-raised p-button-secondary"
          @click="emitChoice(false)"
        />
        <Button
          label="מחיקה"
          icon="pi pi-check"
          class="p-button-raised p-button-danger"
          @keypress.enter="deleteSelectedUser"
          @click="emitChoice(true)"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    title: String,
    context: String,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    emitChoice(choice) {
      this.$emit("choice", choice);
    },
  },
};
</script>


<style >
</style>